import { render, staticRenderFns } from "./VEditButton.vue?vue&type=template&id=1b3c88d2&scoped=true"
import script from "./VEditButton.vue?vue&type=script&lang=js"
export * from "./VEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c88d2",
  null
  
)

export default component.exports